import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from '../../services/order.service';


@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.css']
})
export class OrderConfirmationComponent implements OnInit {

  order: any; // could be typed as Order if backend matches structure exactly

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService
  ) { }

  ngOnInit(): void {
    const orderId = Number(this.route.snapshot.paramMap.get('id'));

    if (orderId) {
      this.orderService.getOrderById(orderId).subscribe({
        next: (data) => {
          this.order = data;
        },
        error: (err) => {
          console.error('Error fetching order details:', err);
        }
      });
    }
  }
}
